<div class="draft-overlay">
  <div class="draft-overlay-inner container-fluid d-flex justify-content-center flex-column">
    <div class="unavailable-image mb-4">
      <img src="/assets/images/Unavailable.svg" alt="Unavailable Image">
    </div>
    <h3>{{formName}}</h3>
    <p class="text-muted">
      {{i18nMessageKey | transloco}}
    </p>
    <p class="credits text-muted small mt-4 pt-4">
      {{'base.powered_by' | transloco}}
      <img src="/assets/images/Paperless_Logo-grey.svg" alt="Paperless Logo" class="ml-2">
    </p>
  </div>
</div>
